export enum AddressTypeEnum {
  Public = 'public',
  Private = 'private',
  Airport = 'airport',
}
